import { render, staticRenderFns } from "./rb_list.vue?vue&type=template&id=445c668b&scoped=true&"
import script from "./rb_list.vue?vue&type=script&lang=js&"
export * from "./rb_list.vue?vue&type=script&lang=js&"
import style0 from "./rb_list.vue?vue&type=style&index=0&id=445c668b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445c668b",
  null
  
)

export default component.exports